export const compareErrors = (a, b) => {
    if (+a.dateRaw > +b.dateRaw) return -1;
    if (+a.dateRaw < +b.dateRaw) return 1;

    return 0;
};

export const clearDuplicates = items => {
    if (!items || !items.length) {
        return items;
    }

    const newItems = [];
    items.forEach(item => {
        newItems[item.title + item.message + item.severity] = item;
    });

    const unickItems = [];
    const keys = Object.keys(newItems);
    keys.forEach(key => {
        unickItems.push(newItems[key]);
    });

    unickItems.sort(compareErrors);

    return unickItems;
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/service/error.algorithms.js